@if (isOpen()) {
<app-modal
  [title]="title() | transloco"
  [text]="text() | transloco"
  [buttonText]="buttonText() | transloco"
  [type]="'primary'"
  (completeModal)="closeAndRedirect()"
  (closeModal)="close()"
></app-modal>
}
